<template>
    <v-form v-model="isValid" @submit.prevent>
        <v-layout>
            <v-flex xs5>
                <calender-text-field
                    v-model="startDate"
                    :max="endDate"
                    :rules="[rules.YYYYMMDDPattern]"
                    :disabled="isDisabled"
                    :label="label"
                    :clearable="clearable"
                />
            </v-flex>
            <v-flex xs1 text-center align-self-center> 〜 </v-flex>
            <v-flex xs5>
                <calender-text-field
                    v-model="endDate"
                    :min="startDate"
                    :rules="[
                        rules.YYYYMMDDPattern,
                        rules.dateStartEndRelationString(startDate, endDate, startLabel, endLabel),
                    ]"
                    :disabled="isDisabled"
                    :clearable="clearable"
                />
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script lang="ts">
import Vue from 'vue';
import { mixins } from 'vue-class-component';
import Component from 'vue-class-component';
import { Prop, Watch, Emit } from 'vue-property-decorator';
import CalenderTextField from './CalenderTextField.vue';
import InputValidation from '../../mixins/InputValidation';

interface DateInterval {
    start?: string;
    end?: string;
}

@Component({
    name: 'DateIntervalField',
    components: { CalenderTextField },
})
export default class DateIntervalField extends mixins(InputValidation) {
    @Prop({
        default: () => ({
            start: undefined,
            end: undefined,
        }),
    })
    value: DateInterval;
    @Prop({ default: '' }) startLabel: string;
    @Prop({ default: '' }) endLabel: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: undefined }) label: string;
    @Prop({ default: false }) clearable: boolean;

    @Watch('value', { immediate: true })
    onValueChanged(val: DateInterval): void {
        this.startDate = val.start;
        this.endDate = val.end;
    }
    @Watch('startDate', { immediate: true })
    onStartDateChanged(val: string): void {
        const newValue = { start: val, end: this.endDate };
        this.input(newValue);
    }
    @Watch('endDate', { immediate: true })
    onEndDateChanged(val: string): void {
        const newValue = { start: this.startDate, end: val };
        this.input(newValue);
    }
    @Watch('isValid', { immediate: true })
    onDateValid(val: boolean): void {
        this.$emit('is-valid', val);
    }
    @Emit()
    public input(value: DateInterval) {}

    startDate = '';
    endDate = '';

    get isDisabled(): boolean {
        return this.disabled;
    }
}
</script>
